import ApiError from '~/types/ApiError';

const FORBIDDEN_STATUS = 403;
const NOT_FOUND_STATUS = 404;
// lib-auth-middleware's text when the caller has no contracting role; a team 403 explains itself.
export const MISSING_ROLE_MESSAGE = 'Authorization failed.';
export const MISSING_ROLE_HELP = 'You need a contracting role to see cases. Ask a contracting admin for access.';

/** What to tell someone whose cases request failed; `subject` names what was loading, e.g. "case 04862168". */
export function casesErrorMessage(
  error: Error,
  subject: string,
  notFoundMessage = `Couldn't find ${subject}.`,
): string {
  if (error instanceof ApiError && error.status === FORBIDDEN_STATUS) {
    return error.message === MISSING_ROLE_MESSAGE ? MISSING_ROLE_HELP : error.message;
  }
  if (error instanceof ApiError && error.status === NOT_FOUND_STATUS) {
    return notFoundMessage;
  }
  return `Couldn't load ${subject}: ${serverMessage(error)}`;
}

// request() prefixes ApiError messages with "Network error received (status code N): "; show the server's own text
function serverMessage(error: Error): string {
  const bodyMessage =
    error instanceof ApiError ? (error.responseBody as { message?: unknown } | undefined)?.message : undefined;
  return typeof bodyMessage === 'string' ? bodyMessage : error.message;
}
